// Not exported: nothing iterates the stages, and the type
// below is the whole public surface. Keeping the array is
// still how the union is spelled here rather than an enum.
const INSIGHT_PIPELINE_STAGES = [
  'copy-to-gcs',
  'import-to-search',
  'parse',
  'extract-metadata',
  'detect-contract-status',
  'embed-identity',
  'index-chunks',
  // Legacy: the pipeline no longer auto-sorts, but rows written
  // before that change can still carry this stage.
  'auto-sort',
  'finalize',
] as const;

export type InsightPipelineStage = (typeof INSIGHT_PIPELINE_STAGES)[number];

/** Shown in the import rail while a document processes. */
export const INSIGHT_PIPELINE_STAGE_LABELS: Record<
  InsightPipelineStage,
  string
> = {
  'copy-to-gcs': 'Copying to search storage',
  'import-to-search': 'Importing to search',
  parse: 'Reading document',
  'extract-metadata': 'Extracting metadata',
  'detect-contract-status': 'Checking signatures',
  'embed-identity': 'Indexing identity',
  'index-chunks': 'Indexing content',
  'auto-sort': 'Filing document',
  finalize: 'Finishing up',
};
